

const splideConfigShopByConcern = {
perPage: 4,
perMove: 1,
gap: '32px',
pagination: false,
arrows: false,
updateOnMove: true,
breakpoints: {
  1120: {
    perPage: 2,
    perMove: 1,
    gap: '32px',
  },
  767: {
    perPage: 1,
    perMove: 1,
    gap: '20px',
  },
  430: {
    perPage: 1,
    perMove: 1,
    gap: '20px',
  },
},
};

let splideInstanceShopByConcern = null;

// Function to initialize Splide
function initSplide() {

if (splideInstanceShopByConcern) {
  splideInstanceShopByConcern.destroy(true);
  splideInstanceShopByConcern = null; // Clear the old instance
}

// Select the slider element
const sliderElement = document.querySelector('#shopByConcern');

// Only initialize if the slider element exists
if (sliderElement) {
  // Create the new instance
  const splide = new Splide(sliderElement, splideConfigShopByConcern);
  
  // Add overflow event handler
  splide.on('overflow', function(isOverflow) {
    const options = {
      pagination: isOverflow,
      drag: isOverflow
    };
    
    // Update the slider options
    splide.options = {...splide.options, ...options};
    
    // Refresh the slider to apply changes
    if (splide.initialized) {
      splide.refresh();
    }
  });
  
  splide.mount();

  splideInstanceShopByConcern = splide;
}
}


document.addEventListener('DOMContentLoaded', initSplide);
document.addEventListener('shopify:section:load', initSplide);